import { useEffect } from "react";

const SITE_SUFFIX = "想要XX";

export default function usePageTitle(title?: string) {
  useEffect(() => {
    if (title) {
      document.title = `${title} - ${SITE_SUFFIX}`;
    }
  }, [title]);
}